module.exports = __webpack_public_path__ + "img/ch10_03_洛丽塔衣橱课.56988930.jpg";